export default [
  {
    key: 'taskId',
    title: '任务ID',
    fixed: 'left',
    width: 46
  },
  {
    key: 'materialId',
    title: '素材ID',
    width: 46
  },
  {
    key: 'materialName',
    title: '素材名称',
    overflow: true
  },
  {
    key: 'content',
    title: '素材',
    width: 108
  },
  {
    key: 'materialType',
    title: '素材类型',
    width: 46
  },
  {
    key: 'upType',
    title: '上传类型',
    width: 46
  },
  {
    key: 'mediaName',
    title: '媒体',
    width: 46
  },
  {
    key: 'accountName',
    title: '账号',
    width: 140
  },
  {
    key: 'toAccountNames',
    title: '被推送账号',
    width: 140,
    overflow: true
  },
  {
    key: 'materialSourceStr',
    title: '来源',
    width: 46
  },
  {
    key: 'opName',
    title: '上传人',
    width: 60
  },
  {
    key: 'createTime',
    title: '任务时间',
    width: 98
  },
  {
    key: 'updateTime',
    title: '更新时间',
    width: 98
  },
  {
    key: 'taskStatus',
    title: '状态',
    overflow: true,
    width: 46
  },
  {
    key: 'mediaMaterialId',
    title: '媒体素材ID',
    overflow: true,
    width: 122
  },
  {
    key: 'control',
    title: '操作',
    width: 52
  }
]
